import type { SessionAnalyticsQuestion } from '../../../../utils/buildSessionAnalytics';
import { AnalyticsEmptyState } from '../AnalyticsEmptyState/AnalyticsEmptyState';
import { ResolvedQuestionRow } from '../ResolvedQuestionRow/ResolvedQuestionRow';
import { List } from './ResolvedQuestionList.styled';

interface ResolvedQuestionListProps {
  questions: SessionAnalyticsQuestion[];
  onGoToSlide: (slideId: string) => void;
}

/**
 * The resolved questions, identical in the side panel and in full screen: only the space
 * around the list changes, so the "nothing resolved yet" rule lives in one place.
 */
export const ResolvedQuestionList = ({
  questions,
  onGoToSlide,
}: ResolvedQuestionListProps) =>
  questions.length === 0 ? (
    <AnalyticsEmptyState />
  ) : (
    <List>
      {questions.map(entry => (
        <ResolvedQuestionRow
          key={entry.question.Id}
          entry={entry}
          onGoToSlide={onGoToSlide}
        />
      ))}
    </List>
  );
